import React from "react";
import styled from "styled-components";
import { Colors } from "../config/Constants";

interface Props {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  labelIcon?: string;
  variant?: string;
  color?: string;
  size?: string;
  startIcon?: string;
  endIcon?: string;
  icon?: string;
  disabled?: boolean;
  width?: string;
  fontColor?: string;
  outlineColor?: string;
  isRounded?: boolean;
}

type StyledLabelProps = {
  disabled: boolean;
};

const Button = ({
  onClick,
  label,
  variant, //'filled' or 'outlined'
  size, //'xs', 'small', 'medium' or 'large'
  isRounded, //true or false
  color,
  startIcon,
  endIcon,
  icon,
  disabled,
  width,
  fontColor,
  outlineColor,
  labelIcon,
}: Props) => {
  return (
    <div style={{ width: width || "100%" }}>
      {icon ? (
        <IconButtonComponent onClick={onClick}>
          <IconButton src={icon} />
        </IconButtonComponent>
      ) : (
        <ButtonComponent
          variant={variant || "outlined"}
          onClick={onClick}
          size={size}
          isRounded={isRounded || false}
          color={color || Colors.white}
          disabled={disabled || false}
          width={width}
          fontColor={fontColor}
          outlineColor={outlineColor}
        >
          {startIcon ? <StartIcon src={startIcon} /> : null}
          {labelIcon ? (
            <LabelIcon src={labelIcon} />
          ) : (
            <StyledLabel disabled={disabled || false}>{label}</StyledLabel>
          )}
          {endIcon ? <EndIcon src={endIcon} /> : null}
        </ButtonComponent>
      )}
    </div>
  );
};
export default Button;

const ButtonComponent = styled.button<Props>`
  color: ${(props) =>
    props.fontColor
      ? props.fontColor
      : props.variant === "outlined"
      ? Colors.black
      : Colors.white};
  border: ${(props) =>
    props.variant === "outlined"
      ? props.outlineColor
        ? "0.0625rem solid " + props.outlineColor
        : "0.0625rem solid " + Colors.black
      : "transparent"};
  font-size: ${(props) => (props.size === "sm" ? "0.75rem" : "1rem")};
  padding: ${(props) => (props.size === "sm" ? "1rem" : "0.75rem")} 0.5rem;
  border-radius: ${(props) =>
    props.size === "sm"
      ? "0.19rem"
      : props.isRounded === false
      ? "0.5rem"
      : "1.25rem"};
  width: ${(props) => props.width || "100%"};
  height: ${(props) =>
    props.size === "sm"
      ? "1.7rem"
      : props.isRounded === true
      ? "2.8rem"
      : "3rem"};
  background-color: ${(props) => (props.disabled ? "#FF333F" : props.color)};
  opacity: ${(props) => (props.disabled ? "50%" : "100%")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-family: ${(props) =>
    props.variant === "outlined" ? "Poppins-Book" : "Poppins-Medium"};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconButtonComponent = styled.button`
  background-color: transparent;
  border: 0rem;
`;

const StartIcon = styled.img`
  margin-left: -1.25rem;
  padding: 0rem 0.94rem;
`;

const LabelIcon = styled.img`
  padding: 0rem 0.25rem;
`;

const EndIcon = styled.img`
  margin-left: 0.625rem;
`;

const IconButton = styled.img`
  width: 1.125rem;
  height: 1.125rem;
`;
const StyledLabel = styled.label<StyledLabelProps>`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
